import * as React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Box,
} from '@mui/material';
import logoSvg from '../img/thinq_app_logo.svg';
import { ReactComponent as Logo } from '../img/thinq_app_logo.svg';
import LanguageIcon from '@mui/icons-material/Language';
import { Link } from 'react-router-dom';
import * as RouterPath from '../data/RouterPath';
import { useNavigate } from 'react-router-dom';
import { useLanguageStore } from '../store/useLanguageStore';
import { useEffect } from 'react';
import { useRegionStore } from '../store/useRegionStore';

export default function Header() {
  const navigate = useNavigate();
  const { language, setLanguage } = useLanguageStore();
  const { region } = useRegionStore();

  useEffect(() => {
    console.log('language', language);
    console.log('region', region);
  }, [language]);

  return (
    <AppBar
      component="header"
      className="header"
      position="fixed"
      color="inherit"
    >
      <Toolbar>
        <Typography variant="h1" sx={{ flexGrow: 1 }}>
          <Link to={RouterPath.TOKENS}>
            {/*<img src={logoSvg} alt="LG ThinQ App Logo" />*/}
            <Logo width="48px" height="48px" />
            <span>LG ThinQ</span>
          </Link>
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <div className="language">
            <TextField
              select
              defaultValue={region === 'KIC' ? 1 : 2}
              size="small"
              sx={{ width: 'max(9.3750vw, 180px)' }}
              onChange={(event) => {
                setLanguage(Number(event.target.value) === 1 ? 'ko' : 'en');
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LanguageIcon />
                  </InputAdornment>
                ),
              }}
            >
              <MenuItem value={1}>
                {language === 'ko' ? '대한민국 / 한국어' : 'Korea / Korean'}
              </MenuItem>
              <MenuItem value={2}>
                {language === 'ko' ? '미국 / English' : 'USA / English'}
              </MenuItem>
            </TextField>
          </div>
          {/*<div className="language">*/}
          {/*  <TextField*/}
          {/*    select*/}
          {/*    defaultValue={1}*/}
          {/*    size="small"*/}
          {/*    sx={{ width: '160px' }}*/}
          {/*    onChange={(event) => {*/}
          {/*      const newRg =*/}
          {/*        Number(event.target.value) === 1*/}
          {/*          ? 'KIC'*/}
          {/*          : Number(event.target.value) === 2*/}
          {/*            ? 'AIC'*/}
          {/*            : 'EIC';*/}
          {/*      setRegion(newRg);*/}
          {/*    }}*/}
          {/*    InputProps={{*/}
          {/*      startAdornment: (*/}
          {/*        <InputAdornment position="start">*/}
          {/*          <LanguageIcon />*/}
          {/*        </InputAdornment>*/}
          {/*      ),*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    <MenuItem value={1}>Region: KIC</MenuItem>*/}
          {/*    <MenuItem value={2}>Region: AIC</MenuItem>*/}
          {/*    <MenuItem value={3}>Region: EIC</MenuItem>*/}
          {/*  </TextField>*/}
          {/*</div>*/}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
